import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import {
    PropertyAgentContactDetailsData,
    PropertyAgentContactDetailsType
} from 'libs/property-ui/src/lib/models/property-agent-contact-details/property-agent-contact-details-model';
import { StepIds } from '../../../../models/property-step/property-step-model';

@Component({
    selector: 'property-summary-agent-contact-detail',
    templateUrl: './summary-agent-contact-detail.component.html',
    styleUrls: ['./summary-agent-contact-detail.component.scss']
})
export class SummaryAgentContactDetailComponent implements OnInit {
    @Input() stepIds: typeof StepIds;
    @Input() contactDetailType: PropertyAgentContactDetailsType;
    @Input() contactDetailData: PropertyAgentContactDetailsData;

    constructor(
        private _changeDetectorRef: ChangeDetectorRef
    ) {
    }

    ngOnInit(): void {
        this._changeDetectorRef.markForCheck();
    }

    get propertyAgentContactDetailsType(): typeof PropertyAgentContactDetailsType {
        return PropertyAgentContactDetailsType;
    }

    get photo() {
        return {
            photoId: this.contactDetailData.brandingImageId,
            plusSize: this.contactDetailData.photoUrl,
            hasError: false
        };
    }
}
